import Typography from "aldoo-ra/Typography"
import Button from "aldoo-ra/Button"
import { PencilIcon } from "@heroicons/react/24/outline"

function StatusDot({ online }) {
  if (online === null)
    return <span className="w-2.5 h-2.5 rounded-full bg-admin_text_secondary/30 animate-pulse" />
  return (
    <span
      className={`w-2.5 h-2.5 rounded-full ${online ? "bg-green-500" : "bg-red-500"}`}
    />
  )
}

function AuthChip({ auth }) {
  if (auth === null) return null
  if (auth)
    return (
      <span className="text-xs px-2 py-0.5 rounded-full border border-blue-400/40 bg-blue-500/10 text-blue-400">
        Authorized
      </span>
    )
  return (
    <span className="text-xs px-2 py-0.5 rounded-full border border-orange-400/40 bg-orange-500/10 text-orange-400">
      Unauthorized
    </span>
  )
}

export default function EnvironmentCard({ environment, status, onEdit }) {
  const online = status?.online ?? null
  const auth = status?.auth ?? null

  const getDomain = (url) => {
    try {
      return new URL(url).hostname
    } catch {
      return url
    }
  }

  return (
    <div className="bg-admin_paper border border-admin_bordered rounded-lg p-6 hover:border-admin_primary transition-colors relative flex flex-col">
      <div className="flex items-start justify-between mb-4 flex-1">
        <div className="flex-1 space-y-2">
          <div className="flex items-center gap-2 flex-wrap">
            <StatusDot online={online} />
            <Typography variant="admin_h4">
              {environment.name}
            </Typography>
            <AuthChip auth={auth} />
          </div>

          {environment.description && (
            <Typography variant="admin_txt2_dim">
              {environment.description}
            </Typography>
          )}
        </div>

        <Button
          variant="admin_icon"
          onClick={() => onEdit(environment)}
          className="h-7 text-admin_text_secondary py-2 px-0"
        >
          <PencilIcon className="w-6 h-6" />
        </Button>
      </div>

      <div className="flex flex-col gap-1.5 pt-3 border-t border-admin_bordered">
        <Typography variant="admin_txt1_dim" className="ml-2">
          {getDomain(environment.api)}
        </Typography>

        <span className="w-fit text-admin_primary text-xs font-mono bg-admin_primary/10 border border-admin_primary/20 rounded-full px-2 py-1">
          {environment.id}
        </span>
      </div>
    </div>
  )
}
